import { useMemo } from 'react';

import dynamic from 'next/dynamic';

import { WebUrlType } from '@api/v3';
import useSearchBar from '@components/views/hooks/useSearchBar';
import { useSearchURL } from '@api/data-loaders/resource';

const SearchBar = dynamic(
  () => import('../../../components/SearchBar/SearchBar'),
  {
    ssr: false,
  }
);

interface Props {
  tourListCount: number;
  type?: 'hotel' | 'tour' | 'ship';
}

const TourListingNotFoundSearchBar = ({ tourListCount, type }: Props) => {
  const urlData = useSearchURL();
  const {
    destination,
    onDestinationChange,
    onDestinationTextChange,
    destinationSearchText,
    errors,
    destinationError,
  } = useSearchBar(type, urlData?.text || '');

  // ====================================================
  // we should do shallow push when the user search for a tour listing
  // ====================================================
  const shouldShallowPush = useMemo(() => {
    return (
      destination?.type === WebUrlType.TOUR_CITY ||
      destination?.type === WebUrlType.TOUR_TYPE ||
      destination?.type === WebUrlType.TOUR_THEME ||
      destination?.type === WebUrlType.TOUR_REGION ||
      destination?.type === WebUrlType.TOUR_COUNTRY ||
      destination?.type === WebUrlType.TOUR_CATEGORY ||
      destination?.type === WebUrlType.CRUISE_THEME ||
      destination?.type === WebUrlType.CRUISE_REGION ||
      destination?.type === WebUrlType.CRUISE_PORT ||
      destination?.type === WebUrlType.CRUISE_CATEGORY
    );
  }, [destination]);

  return (
    <>
      <SearchBar
        tourListing={true}
        tourListCount={tourListCount || 0}
        type={type}
        destinationError={destinationError}
        shouldShallowPush={shouldShallowPush}
        destination={destination}
        onDestinationChange={onDestinationChange}
        onDestinationTextChange={onDestinationTextChange}
        destinationSearchText={destinationSearchText}
        errors={errors}
        detail
      />
    </>
  );
};

export default TourListingNotFoundSearchBar;
